import { isPlatformBrowser } from '@angular/common';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class StorageService {

  constructor(@Inject(PLATFORM_ID) private platformId: Object) {}

  /**
   * Guarda un valor en sessionStorage
   */
  setItem(key: string, value: string): void {
    if (isPlatformBrowser(this.platformId)) {
      sessionStorage.setItem(key, value);
    }
  }

  /**
   * Obtiene un valor de sessionStorage
   */
  getItem(key: string): string | null {
    if (!isPlatformBrowser(this.platformId)) {
      return null;
    }
    return sessionStorage.getItem(key);
  }

  /**
   * Elimina un valor de sessionStorage
   */
  removeItem(key: string): void {
    if (isPlatformBrowser(this.platformId)) {
      sessionStorage.removeItem(key);
    }
  }

  /**
   * Limpia todo el sessionStorage
   */
  clear(): void {
    if (isPlatformBrowser(this.platformId)) {
      sessionStorage.clear();
    }
  }

  /**
   * Verifica si una clave existe en sessionStorage
   */
  hasItem(key: string): boolean {
    if (!isPlatformBrowser(this.platformId)) {
      return false;
    }
    return sessionStorage.getItem(key) !== null;
  }
}
